import type { GetActionItemsProps } from '@app/pages/Analytics/AnalyticsLayout/types';
import { getAnalyticsReportTitle } from '@app/pages/Analytics/utils';

import type { MenuProps } from 'antd';

export const getActionItems = ({
  exportCurrentReport,
  exportAllReports,
  activeTab,
}: GetActionItemsProps) => {
  const actionItems: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <span
          onClick={exportCurrentReport}
        >{`Экспортировать '${getAnalyticsReportTitle(activeTab)}'`}</span>
      ),
    },
    {
      key: '2',
      label: (
        <span onClick={exportAllReports}>Экспортировать всю аналитику</span>
      ),
    },
  ];

  return actionItems;
};
